import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Snowfall from "react-snowfall";
import videojs from "video.js";
import "video.js/dist/video-js.css"; // Импорт CSS для video.js (если необходимо)

import { useAppDispatch } from "../../hooks/redux-hooks";
import ScrollUp from "../../components/scrollUp/ScrollUp";
import Header from "./components/header/Header";
import Splash from "../../assets/icon/Splash";
import button from "../../assets/rizdvoniki/button.png";
import rizdvonikiDesctop from "../../assets/rizdvoniki/rizdvoniki.png";
import rizdvonikiMobile from "../../assets/rizdvoniki/rizdvonikiMobile.png";
import snow from "../../assets/rizdvoniki/snow.png";
import Footer from "./components/footer/Footer";
import Button from "../../assets/rizdvoniki/icon/Button";
import diploma from "../../assets/rizdvoniki/diploma1.jpg";
import ButtonStop from "../../assets/rizdvoniki/icon/ButtonStop";

const Rizdvoniki = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);
  const audioRef = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayButtonClick = () => {
    const audioPlayer = videojs(audioRef.current);

    if (!isPlaying) {
      audioPlayer.src({
        src: "https://hls.radio.silpo.ua/hls/3d34f2af-be39-4a50-a349-46cc823d48dd.m3u8",
        type: "application/x-mpegURL",
      });
      audioPlayer.play();
      setIsPlaying(true);
    } else {
      audioPlayer.pause();
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    const splashTimer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => {
      clearTimeout(splashTimer);
    };
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <>
      {showSplash ? (
        <div>
          <div className="min-w-scroon min-h-screen flex justify-center items-center bg-white z-50">
            <Splash />
          </div>
        </div>
      ) : (
        <div className="relative flex flex-col justify-center items-center w-full h-full md:bg-white">
          <Snowfall snowflakeCount={100} />
          <Header />
          <div className="w-full relative min-h-[calc(100vh_-_15.4rem)]  bg-white">
            <Snowfall snowflakeCount={100} />

            <div className="w-full flex flex-col justify-center items-center overflow-x-hidden">
              <div
                className="w-screen flex flex-col items-center bg-bg_lending bg-no-repeat"
                style={{
                  backgroundPosition: "center",
                  backgroundSize: "auto 100%",
                }}
              >
                <div className="w-full min-w-[20rem] flex flex-col items-center justify-center pt-5 px-5">
                  <div className="block ml-[-20px] md:hidden">
                    <img
                      src={rizdvonikiMobile}
                      className="min-w-[18.75rem] h-auto "
                      alt="rizdvoniki"
                    />
                  </div>
                  <div className="hidden md:block">
                    <img
                      className="min-w-[18.75rem] max-w-[18.75rem] h-auto"
                      src={rizdvonikiDesctop}
                      alt="rizdvoniki"
                    />
                  </div>

                  <h3 className="py-5 text-5xl leading-[100%] text-center font-[NovitoNova] md:max-w-[47rem] md:text-[56px] md:pt-10 md:leading-[56px] text-white uppercase pl-5">
                    Гості «Сільпо» встановили співочий
                    рекорд&nbsp;&nbsp;&nbsp;України з наймасовішого запису
                    «Щедрика»
                  </h3>
                  <div className="w-full max-w-[530px] h-auto flex justify-center items-center">
                    <img
                      src={diploma}
                      alt="diploma"
                      className="w-full rounded-lg"
                    />
                  </div>

                  <div className="md:max-w-[35.5rem] text-lg px-5 text-white">
                    <p className="text-center py-5 leading-7">
                      Упродовж двох тижнів усі охочі могли заспівати цю
                      всесвітньо відому щедрівку в чат-боті{" "}
                      <Link to="https://t.me/Radio_Silpo_bot" target="_blank">
                        @radio_silpo_bot
                      </Link>
                      . Ми отримали майже дві з половиною тисячі заявок та
                      відібрали з них 302 найкращих голосів, після чого
                      обʼєднали їх у єдину аудіоверсію. Фінальний трек ми з
                      турботою звели на студії звукозапису Soda Music та
                      випустили в етер на «Радіо Сільпо».
                    </p>
                  </div>
                  <div className="w-full max-w-[30rem]">
                    <audio ref={audioRef} className="hidden" />
                    <div
                      className="w-full"
                      style={{
                        backgroundImage: `url(${snow})`,
                        backgroundPosition: "95% 100%",
                        backgroundSize: "100% 95%",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="w-full flex flex-col items-center justify-center overflow-hidden pt-5">
                        {/* <h3 className="max-w-[20rem] pt-10 pb-2 text-5xl leading-10 text-center font-[NovitoNova] text-[#113D28] uppercase">
                          Лунає у всіх супермаркетах «Сільпо»
                        </h3> */}
                        <button
                          onClick={handlePlayButtonClick}
                          className="relative py-7 min-w-[19rem] max-w-[19rem] transition duration-300 ease-in-out transform hover:scale-110 "
                        >
                          <img src={button} alt="button" />
                          <span className="absolute top-[3.7rem] left-[2.9rem] flex items-center text-5xl text-white leading-9 text-center font-[NovitoNova] uppercase">
                            <span
                              className={`${
                                isPlaying ? "pr-9" : "pr-5"
                              } pt-1 transition transform ease-in-out`}
                            >
                              {isPlaying ? <ButtonStop /> : <Button />}
                            </span>
                            {isPlaying ? "ЗУПИНИТИ" : "ПРОСЛУХАТИ"}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ScrollUp />
          <div className="w-full bg-white">
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default Rizdvoniki;
